import { haveAnyValue } from 'src/utils/utilitiesV2'
import felDocumentTypes from 'src/enums/felDocumentTypes'

const getDocumentType = (docType: number): IFelDocumentType => {
  if (!haveAnyValue(docType)) return { label: 'Sin seleccionar', value: null }
  return felDocumentTypes.find((dt: IFelDocumentType) => dt.value === docType)
}

export { getDocumentType }
